import React from 'react';
import { fmtDec } from '../utils';

export default function CommissionRates({ data }) {
  const { commissionRates = [], commissionSummary = [] } = data;
  const getSummary = (name) => commissionSummary.find(s => s.name.toLowerCase().includes(name.split(' ')[0].toLowerCase()));

  return (
    <div className="table-card">
      <div className="table-header"><span className="table-header-title">Commission rates by rep</span></div>
      <div className="table-wrap">
        <table>
          <thead><tr><th>Rep</th><th>Rate</th><th>Structure</th><th>Item total</th><th>Commission earned</th></tr></thead>
          <tbody>
            {commissionRates.map(r => {
              const s = getSummary(r.name);
              return (
                <tr key={r.name}>
                  <td style={{ fontWeight: 500 }}>{r.name}</td>
                  <td>
                    {r.rate === 0
                      ? <span className="badge badge-gray">0%</span>
                      : r.rate >= 7
                      ? <span className="badge badge-green">{r.rate}%</span>
                      : <span className="badge" style={{background:'var(--blue-bg)',color:'var(--blue)'}}>{r.rate}%</span>}
                  </td>
                  <td>
                    {r.type === '—' ? <span style={{ color: 'var(--text3)' }}>—</span>
                      : r.type === 'Fixed' ? <span className="badge badge-amber">Fixed</span>
                      : <span className="badge badge-brand">Tiered</span>}
                  </td>
                  <td className="td-money">{s ? fmtDec(s.itemTotal) : '—'}</td>
                  <td className="td-money" style={{ color: 'var(--green)' }}>{s ? fmtDec(s.commission) : '—'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
